<script setup lang="ts">
  import { computed } from 'vue'
  import { globalUtils } from '@gat-ship/utils'

  const theme = globalUtils.composables.useTheme()

  const src = computed(() => {
    return theme.isLight.value
      ? new URL('../assets/Gatship_logo_full_RGB.svg', import.meta.url).href
      : new URL('../assets/Gatship_logo_full_white_RGB.svg', import.meta.url)
          .href
  })
</script>
<template>
  <img :src="src" />
</template>
